import { useEffect, useRef } from "react";

const isDev =
  process.env.NODE_ENV !== "production" ||
  window.location.hostname === "localhost";

const FORMAT_CONFIG = {
  auto: {
    style: { display: "block", minHeight: 90, margin: 'auto' },
    label: "Responsive Ad",
  },
  horizontal: {
    style: { display: "block", minHeight: 90, margin: 'auto' },
    label: "Horizontal Ad",
  },
  vertical: {
    style: {
      display: "block",
      width: 300,
      height: 600,
    },
    label: "Vertical Ad (300x600)",
  },
};

const AdsenseAd = ({ dataAdSlot, format = "auto" }) => {
  const adRef = useRef(null);
  const cfg = FORMAT_CONFIG[format] ?? FORMAT_CONFIG.auto;

  useEffect(() => {
    if (isDev) return;
    if (!window.adsbygoogle || !adRef.current) return;

    const alreadyRendered =
      adRef.current.getAttribute("data-adsbygoogle-status") === "done";

    if (alreadyRendered) return;

    try {
      window.adsbygoogle.push({});
    } catch (e) {
      console.error("AdSense script error:", e);
    }
  }, [dataAdSlot, format]);

  // 🔧 DEV PLACEHOLDER
  if (isDev) {
    return (
      <div
        style={{
          ...cfg.style,
          border: "2px dashed #bbb",
          background: "#f7f7f7",
          color: "#777",
          fontSize: 12,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textTransform: "uppercase",
          letterSpacing: 1,
        }}
      >
        {cfg.label}
      </div>
    );
  }

  // 🌍 REAL ADSENSE
  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={cfg.style}
      data-ad-client="ca-pub-2289204592778773"
      data-ad-slot={dataAdSlot}
      {...(format !== "vertical" && {
        "data-ad-format": "auto",
        "data-full-width-responsive": "true",
      })}
    />
  );
};

export default AdsenseAd;
